;(function() {
  'use strict'

  Controller.$inject = ["$state", "app", "glAnalytics", "glError", "configService", "StateFactory", "zoneService", "websiteService"];
  angular.module('app.zone').controller('Zone', Controller)

  /* @ngInject */
  function Controller(
    $state,
    app,
    glAnalytics,
    glError,
    configService,
    StateFactory,
    zoneService,
    websiteService
  ) {
    var ctrl = this

    ctrl.$onInit = onInit

    function onInit() {
      ctrl.businessUrl = configService.getSubscriberPortalUrl('/projects')
      ctrl.glowUrl = websiteService.getWebsiteUrl()

      ctrl.year = moment().format('YYYY')
      ctrl.state = new StateFactory(['loading', 'ready'])

      ctrl.referrer = $state.params.referrer || window.referrer || 'none'
      glAnalytics.track('Zone', 'Referrer', ctrl.referrer)

      ctrl.themeName = $state.params.themeName || 'glow'
      ctrl.code = $state.params.code

      ctrl.state.loading()
      zoneService
        .getTheme(ctrl.themeName)
        .then(function(theme) {
          ctrl.theme = theme
          app.setTitle(ctrl.theme.title)
          ctrl.state.ready()
        })
        .catch(glError.fromStatus)
    }
  }
})()
